import { render, staticRenderFns } from "./PosVersions.vue?vue&type=template&id=2cfe80d9&"
import script from "./PosVersions.vue?vue&type=script&lang=js&"
export * from "./PosVersions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports